export default __webpack_public_path__ + "static/signet-fee5741caee472fa3905734e018e075d.png";